<template>
  <div class="row">
    <div
      v-show="displayFilter"
      id="catalog-filter"
      class="col-12 col-lg-3 catalog__filter"
      :class="{ active: isActive }"
    >
      <button type="button" class="close" aria-label="Close">
        <span aria-hidden="true" @click="showFilter"> &times; </span>
      </button>
      <div class="filter-block">
        <div class="catalog-title">
          {{ $t("Filter") }}
        </div>
        <!--<div class="filter-block__button">-->
        <!--<button-->
        <!--class="reg-btn"-->
        <!--data-toggle="modal"-->
        <!--data-target="#myModal">-->
        <!--{{ $t('Get the Best Deal') }}-->
        <!--</button>-->
        <!--</div>-->
        <filter-block
          v-if="filter"
          ref="filter"
          :initial-fields="filter"
          :initial-data="filter"
          :disable-save-button="disableSaveButton"
          :lock-save-button="lockSaveButton"
          @submit="filterSubmit"
        />
      </div>
    </div>
    <div
      :class="
        displayFilter
          ? 'col-12 col-md-12 col-lg-9 catalog__blocks'
          : 'col-12 catalog__blocks'
      "
    >
      <div class="catalog__top">
        <div class="catalog__top-left">
          <span class="h4">
            {{ $t("{total} QTY", { total }) }}
          </span>
        </div>
        <div class="catalog__top-right">
          <div class="catalog__top-options">
            <span v-if="displayPagination" class="inline-block">
              <div class="small-sub">{{ $t("View") }}:</div>
              <div class="options-wrap">
                <span
                  v-for="view in viewCounts"
                  :key="view"
                  :class="{ active: view == params.per_page }"
                  @click="perPage(view)"
                >
                  {{ view }}
                </span>
              </div>
            </span>

            <span v-if="displayPagination" class="inline-block">
              <div class="small-sub">{{ $t("Sort") }}:</div>

              <label class="select-label">
                <select
                  v-model="params.sorting"
                  class="form-control options-select"
                  @change="sortingSubmit"
                >
                  <option v-for="(label, key) in sorts" :key="key" :value="key">
                    {{ label }}
                  </option>
                </select>
              </label>
            </span>
          </div>
        </div>
        <a
          style="color: #fff"
          class="mt-3 reg-btn filter-btn"
          data-target="catalog-filter"
          @click="showFilter"
        >
          {{ $t("Filter") }}
        </a>
      </div>
      <div class="catalog__blocks-wrap">
        <item
          v-for="item in items"
          :key="item.id"
          :item="item"
          @hovered="$emit('hovered', item)"
        />
      </div>
      <div
        v-if="displayPagination"
        class="d-flex flex-wrap w-100 pagination-row justify-content-center"
      >
        <paginate
          :page-count="pages"
          :click-handler="setPage"
          container-class="pagination"
          prev-class="page-item previous"
          prev-link-class="page-link"
          next-class="page-item next"
          next-link-class="page-link"
          page-class="page-item"
          page-link-class="page-link"
        />
      </div>
    </div>
  </div>
</template>

<script>
import assign from "lodash-es/assign";
import Item from "./Item.vue";
import Paginate from "vuejs-paginate";
import FilterBlock from "./Filter.vue";
import isNull from "lodash-es/isNull";
import cloneDeep from "lodash-es/cloneDeep";
import pickBy from "lodash-es/pickBy";

export default {
  name: "Results",

  components: {
    FilterBlock,
    Item,
    Paginate,
  },

  props: {
    displayFilter: {
      type: Boolean,
      default: true,
    },
    displayPagination: {
      type: Boolean,
      default: true,
    },
    displaySort: {
      type: Boolean,
      default: true,
    },
  },

  data: () => {
    return {
      items: [],
      total: null,
      pages: 0,
      title: null,
      viewCounts: [],
      sorts: {},
      params: {
        page: 1,
        per_page: 10,
        sorting: "date",
        context: "list",
      },
      filter: null,
      filterParams: {},
      filterWatching: false,
      lockSaveButton: false,
      disableSaveButton: false,
      isActive: false,
    };
  },

  mounted() {
    // if displayFilter prop is set to false
    // this.$refs.filter will be undefined
    if (this.$refs.filter) {
      this.$refs.filter.submit();
      setTimeout(() => {
        this.$refs.filter.startWatch();
      }, 500);
    }
  },

  methods: {
    load() {
      // disable save button
      this.disableSaveButton = true;
      delete this.filterParams.payment_method;

      this.$http
        .get("companies", {
          params: assign(
            {
              with: "saved",
            },
            this.params,
            this.filterParams
          ),
        })
        .then((response) => {
          this.items = response.data.data;
          this.total = response.data.meta.total;
          this.pages = response.data.meta.last_page;
          this.viewCounts = response.data.viewCounts;
          this.sorts = response.data.sorts;
          this.$refs.filter.hydrateFields(response.data.filter);

          this.lockSaveButton = !!response.data.savedSearch;
          //enable save button
          this.disableSaveButton = false;

          // update browser location
          const resUrl = response.request.responseURL;
          const queryString = resUrl.substring(resUrl.indexOf("?"));
          const origin = location.href.substring(
            0,
            location.href.indexOf(location.search)
          );
          const newUrl = origin + queryString;

          history.pushState({ path: newUrl }, "", newUrl);

          this.$emit("loaded", response.data, this.filterParams);
        });
      this.scrollToTop();
    },

    filterSubmit(data) {
      let params = cloneDeep(data);
      params.price = pickBy(params.price, (value) => {
        return !isNull(value);
      });

      this.filterParams = params;
      this.params.page = 1;
      this.load();
    },

    sortingSubmit() {
      this.params.page = 1;
      this.load();
    },

    setPage(num) {
      this.params.page = num;
      this.load();
    },

    perPage(val) {
      this.params.page = 1;
      this.params.per_page = val;
      this.load();
    },
    showFilter() {
      this.isActive = !this.isActive;
    },
    scrollToTop() {
      $("html, body").animate({ scrollTop: 400 }, 600);
      return false;
    },
  },
};
</script>
